import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Params } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as fromFilters from '~app/modules/filters/store';

@Component({
  selector: 'app-search-brand-plp-actions',
  templateUrl: './brand-plp-actions.component.html',
  styleUrls: ['./brand-plp-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandPlpActionsComponent {
  @Input() queryParams: Params;
  @Input() isSticky = false;
  @Output() filterOpened = new EventEmitter<void>();

  filtersCount$ = this.store.pipe(select(fromFilters.getFiltersCount));
  constructor(private store: Store<fromFilters.State>) {}

  onOpenFilters(): void {
    this.filterOpened.emit();
  }
}
